import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import SAFARI from 'url:../assets/images/anti-human-safari.jpg'
import LanguageSelector from '../components/LanguageSelector'

export default function NotFound() {
  const { t } = useTranslation()

  useEffect(() => {
    // The .htaccess serves index.html for any unknown path, so this renders
    // under a 200 — tell crawlers not to index it
    const meta = document.createElement('meta')
    meta.name = 'robots'
    meta.content = 'noindex, follow'
    document.head.appendChild(meta)
    return () => meta.remove()
  }, [])

  return (
    <main className='relative flex min-h-screen w-full flex-col items-center justify-center gap-8 bg-zinc-950 p-6 py-16 text-center text-grey-300 md:py-20'>
      <LanguageSelector />
      <img
        src={SAFARI}
        alt={t('logoAlt')}
        className='h-30 w-30 rounded-full border-2 border-white object-cover'
      />

      <h1 className='px-4 text-2xl font-medium text-white'>{t('notFoundTitle')}</h1>
      <p className='mb-2 w-full px-4 text-lg text-white opacity-90 md:max-w-xl'>
        {t('notFoundMessage')}
      </p>

      <a
        href='/'
        className='rounded-sm border-2 border-zinc-400 bg-black px-8 py-3 text-xl font-medium text-gray-300 focus:outline-none focus:ring-2 focus:ring-white'
      >
        {t('backHome')}
      </a>
    </main>
  )
}
